export default __webpack_public_path__ + "static/media/img-0765-slovenia-premium-face.a5d8c80b.png";